export default __webpack_public_path__ + "static/biotech-9df00819b6db05535f8f75a837dacd0f.jpg";